import { Select, type SelectProps } from 'antd';
import styled from 'styled-components';

const StyledSelect = styled(Select)`
  .ant-select-selector {
    height: 22px !important;
    padding-block: 0 !important;
    font-weight: 600;
    font-size: 12px;
  }

  .ant-select-selection-item {
    line-height: 20px !important;
    font-size: 12px;
  }
`;

export function RichTextMenuSelect(props: SelectProps) {
  return <StyledSelect size="small" {...props} />;
}
